export default {"src":"/_next/static/media/tv.b2dab659.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};